import { useWorkspace } from "#app/lib/data/app-provider";
import { useInvitableRoles } from "./use-invitable-roles";

// Invite availability is grant-driven: the role_invite_grant grid is the
// source of truth for who can invite whom, so invite affordances show
// only when the actor can invite into at least one role — not based on
// a permission key like manage.users.
export function useCanInvite(): boolean {
  const { activeWorkspace } = useWorkspace();
  const { allowedRoleIds } = useInvitableRoles(
    activeWorkspace?.workspaceId ?? "",
  );
  return allowedRoleIds.length > 0;
}
